export const config = {
  //DEV==============================================
  //apiEndpoint: "https://appd-as09:4546/Workshops",
  //**PROD===========================================
  apiEndpoint: "https://workshopapi.surreyschools.ca/Workshops",
  registrationClientUrl: "https://workshopreg.surreyschools.ca",
  helpSiteUrl:
    "https://sd36.sharepoint.com/sites/prioritypractices1/SitePages/Workshop-Admin-Help.aspx",
};

export const msalConfig = {
  auth: {
    //clientId: "617f5c84-4fa0-4ea5-b6c8-c062cc0a39ef",
    clientId: "ccb54395-55fe-437e-a7a4-93d4036772e6",
    authority:
      "https://login.microsoft.com/08b4e9cf-8113-420d-ba07-52f7d4df8acd", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    //LOCAL===========================================
    //redirectUri: "http://localhost:3000",
    //DEV=============================================
    //redirectUri: "https://appd-as09:4548",
    //**PROD============================================
    redirectUri: "https://workshopadmin.surreyschools.ca",

    scopes: ["User.Read", "User.Read.All", "User.ReadBasic.All", "People.Read"],
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  workshopApiScopes: [
    "api://9eac46f8-a1c2-4f98-9505-6f1ea4f9d4c0/Workshops.Read.All",
  ],
};
